<h5>{{ 'TOOLTIP_COMPARISON' | translation }}</h5>

<div class="comparison" *ngFor="let c of comparisons">
    <div class="info" *ngIf="!!setPrecision(c.value)">
        <div>{{ c.date }}</div>
        <div>{{ setPrecision(c.value) }} {{ totalComparison.unit }}</div>
    </div>
    <div *ngIf="!!setPrecision(c.value)" class="bar" [ngStyle]="{ 'width': c.barWidth, 'background': c.color }"></div>
</div>